export default __webpack_public_path__ + "static/media/img-1.09d88a7a.jpg";